export default __webpack_public_path__ + "static/media/packaging.dbad52be.png";